var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',_vm._l((_vm.colors),function(color){return _c('li',{key:color.name,style:({ 'background-color': '#' + color.rgb }),on:{"click":function($event){_vm.clickColor(color)}}},[_vm._v("\n     \n  ")])}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-73644f34","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/helpers/vue-color-picker.vue
// module id = 138
// module chunks = 0